import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';

new Swiper('.component-reference-featured .swiper', {
  modules: [Navigation, Pagination, Autoplay],
  slidesPerView: 5,
  spaceBetween: 24,
  centeredSlides: true,
  loop: true,
  grabCursor: false,
  autoplay: false,
  pagination: {
    el: '.component-reference-featured .swiper-pagination',
    type: 'progressbar',
    clickable: true,
  },
  navigation: {
    nextEl: '.component-reference-featured .swiper-button-next',
    prevEl: '.component-reference-featured .swiper-button-prev',
  },
  breakpoints: {
    300: {
      slidesPerView: 1,
      spaceBetween: 0,
    },
    576: {
      slidesPerView: 2,
      spaceBetween: 40,
    },
    992: {
      slidesPerView: 3,
      spaceBetween: 12,
    },
    1200: {
      slidesPerView: 4,
    },
    1800: {
      slidesPerView: 5,
      spaceBetween: 24,
    },
    2000: {
      slidesPerView: 6,
      spaceBetween: 24,
    }
  }
});
